import Service from './service.js';

export class Redirection extends Service {
    constructor() {
        super('#form-service-redirection', 'redirection');
        
        this.salutation = document.querySelector('#redirection-salutation');
        this.title = document.querySelector('#redirection-title');
        this.firstname = document.querySelector('#redirection-firstname');
        this.lastname = document.querySelector('#redirection-lastname');
        this.email = document.querySelector('#redirection-email');
        this.street = document.querySelector('#redirection-street');
        this.housenumber = document.querySelector('#redirection-housenumber');
        this.postcode = document.querySelector('#redirection-postcode');
        this.city = document.querySelector('#redirection-city');
        this.country = document.querySelector('#redirection-country');
        this.note = document.querySelector('#redirection-note');
        this.deliverystart = document.querySelector('[name="Redirection[deliverystart]"]');
        this.deliveryend = document.querySelector('[name="Redirection[deliveryend]"]');

        this.addresses = document.querySelector('.addresses');
        this.summaryAddress = document.querySelector('.summary-address');
        
        this.initService();
    };

    initService() {
        if(this.addresses) {
            let nodes = this.addresses.querySelectorAll('input');
            nodes.forEach(node => {
                node.addEventListener('change', event => {
                    this.updateForm(event.currentTarget.dataset);
                });
            });
        }
    };
    
    afterValidate(data) {
        if(data.status == 'ok') {
            this.validated = true;
            this.deliverinfo = data.deliverinfo;
            this.deliverystart.value = data.deliverystart;
            this.deliveryend.value = data.deliveryend;
            this.updateSummary();
            this.clearErrors();
            this.next();
        } else {
            this.error(data.error);
        }
    };
    
    updateSummary() {
        let address = this.salutation.value + ' ' + this.title.value + ' ' + this.firstname.value + ' ' + this.lastname.value;
        address += '<br>' + this.street.value + ' ' + this.housenumber.value;
        address += '<br>' + this.postcode.value + ' ' + this.city.value;
        address += '<br>' + this.country.value;
        
        this.summaryAddress.innerHTML = address;
        
        super.updateSummary();
    };
    
    updateForm(data) {
        this.salutation.value = data.salutation;
        this.title.value = data.title;
        this.firstname.value = data.firstname;
        this.lastname.value = data.lastname;
        this.email.value = data.email;
        this.street.value = data.street;
        this.housenumber.value = data.housenumber;
        this.postcode.value = data.postcode;
        this.city.value = data.city;
        this.country.value = data.country;
        this.note.value = data.note;
    };
};
